export type LinkMetadata = {
	trackingEvent?: unknown;
	noFollow?: boolean;
	target?: string;
	rel?: string;
};

export function getLinkAttributes(link?: LinkMetadata) {
	const rel = new Set(link?.rel?.split(/\s+/).filter(Boolean));
	if (link?.noFollow) rel.add("nofollow");
	if (link?.target === "_blank") {
		rel.add("noopener");
		rel.add("noreferrer");
	}
	return {
		"data-tracking-event":
			typeof link?.trackingEvent === "string"
				? link.trackingEvent.trim() || undefined
				: undefined,
		rel: rel.size ? [...rel].join(" ") : undefined,
	};
}
